import { GetAccountAssetsResponse } from "@syla/shared/types/responses/GetAccountAssetsResponse";
import axios from "axios";

export async function getAccountAssets(
  accountId: string,
): Promise<GetAccountAssetsResponse> {
  const response = await axios.get<GetAccountAssetsResponse>(
    `/accounts/${accountId}/assets`,
  );
  return response.data;
}
